import { useEffect, useState } from "react";
import { _IndirectCost, _Labour, _LabourType, _single } from "../../../../core/services/dataBean/EntityCatalog";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { BasicTable, MASK_MONEY } from "../../../theme/Component/BasicTable";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { Modal } from "../../../theme/Component/Modal";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { SelectorUmeasurement } from "../../../bpm/config/Componentes/SelectorUmeasurement";
import { SelectIndirectConstType } from "../../IndirectCostType/SelectIndirectConstType";
import { toast } from "react-toastify";
import { InputMoney } from "../../../theme/Input/InputMoney";
import { CostingMeasurementConstantsSelect } from "../../ResourceCost/CostingMeasurementConstantsSelect";


interface Props {
    idManufacturingStardard: number;
}

export const IndirectCost = ({ idManufacturingStardard }: Props) => {

    const { lista, setLista, bean, setBean, instance, update, handleChange, deleteItemVoid } = useDataBean(_IndirectCost);

    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });


    useEffect(() => {
        getLista()
    }, [idManufacturingStardard])

    const getLista = () => {
        instance.getIndirectCostCatalog(idManufacturingStardard).then(
            (rta: any) => {
                setLista(rta)
            }
        ).catch(
            err => { console.log(err) }
        )
    }

    const editaItem = () => {
        update().then(
            (resp) => {
                getLista();
                setModal({ ...modal, "view": false })
            }
        ).catch(
            err => { console.log(err) }
        )
    }

    const deleteObjec = () => {
        deleteItemVoid(bean.IDIndirectCost).then(
            (resp) => {
                getLista();
                setModalC({ ...modalC, "view": false })
            }
        ).catch(
            err => { console.log(err) }
        )
    }

    const head = [
        { title: 'ID', property: 'IDIndirectCost', visible: true },
        { title: 'Tipo de Costo Indirecto', property: 'IndirectCostTypeName', visible: true },
        { title: 'Cuenta Contable', property: 'AccountantIDStrName', visible: true },
        { title: 'Centro de Costo', property: 'CostingCenterName', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Unidad de Medida', property: 'MeasurementUnitName', visible: true },
        { title: 'Cantidad', property: 'Quantity', visible: true },
        { title: 'Costo Unitario', property: 'UnitaryCost', visible: true, mask: MASK_MONEY },
        { title: 'Empleado', property: 'EmployeeName', visible: true },
    ]

    const create = () => {
        setBean({
            IDEmployee: _single.getAccountID(),
            IDManufacturingStardard: idManufacturingStardard,
        });
        setModal({ ...modal, "view": true, "name": "Agregar Costo Indirecto" });
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { setModal({ ...modal, "view": true, "name": "Editar Costo Indirecto" }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true, "name": `Eliminar Costo Indirecto` }) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const [missingFields, setMissingFields] = useState<string[]>([]);

    const validateData = () => {
        if (validateForm() > 0) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        } else {
            editaItem();
        }
    }

    const validateForm = () => {
        const requiredFields = [
            "Name", "IDIndirectCostType", "IDMeasurementUnit", "Quantity", "UnitaryCost",
        ];

        let missing = [];
        for (let field of requiredFields) {
            if (bean[field] === null || bean[field] === undefined || bean[field] === "") {
                missing.push(field);
            }
        }
        setMissingFields(missing);
        return missing.length;
    };

    return (
        <div className="row">
            <div className="col-md-12">
                <BasicTable listButtons={listaBotones()} head={head} body={lista} rowSet={setBean} iconButtons={iconButtonsItem} />
            </div>


            <div className="col-md-12">
                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteObjec}>
                    <strong>Eliminar Informacion de {bean.IDIndirectCost} - {bean.Name}</strong>
                </ModalConfirm>
            </div>

            <div className="col-md-12">
                <Modal modal={modal} updateModal={setModal} eventModal={validateData}>
                    <div className="row">
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('Name') ? 'has-error' : ''}`}>Nombre</label>
                            <input type="text" name="Name" className="form-control" value={bean.Name} onChange={handleChange} />
                        </div>
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('IDIndirectCostType') ? 'has-error' : ''}`}>Tipo de Costo Indirecto</label>
                            <SelectIndirectConstType idSelector={bean.IDIndirectCostType} onChange={(e) => { setBean({ ...bean, "IDIndirectCostType": e.IDIndirectCostType }) }} label=" " returnType="Object" />
                        </div>
                        <div className="col-md-12">
                            <label>Descripción</label>
                            <textarea name="Description" className="form-control" value={bean.Description} onChange={handleChange} />
                        </div>
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('IDMeasurementUnit') ? 'has-error' : ''}`}>Unidad de Medida</label>
                            {/* <SelectorUmeasurement idSelector={bean.IDMeasurementUnit} onChange={(e) => { setBean({ ...bean, "IDMeasurementUnit": e }) }} titulo=" " /> */}
                            <CostingMeasurementConstantsSelect idSelector={bean.IDMeasurementUnit} onChange={(e) => { setBean({ ...bean, "IDMeasurementUnit": e }) }} />
                        </div>
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('Quantity') ? 'has-error' : ''}`}>Cantidad</label>
                            <input type="number" name="Quantity" className="form-control" value={bean.Quantity} onChange={handleChange} />
                        </div>
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('UnitaryCost') ? 'has-error' : ''}`}>Costo Unitario</label>
                            <InputMoney _value={bean.UnitaryCost} onChange={(e) => { setBean({ ...bean, "UnitaryCost": e }) }} _label=" " />
                        </div>
                        {/* <PrintJson json={bean} /> */}
                    </div>
                </Modal>
            </div>
        </div >
    )
}



